import Field from './Field';

export default class Select extends Field {

    constructor() {
        super();
        this.type = 'Select';
        this.maxSize = [32, 2];
        this.minSize = [2, 1];
    }
    
    create(target, options) {
        let container = document.createElement('div');
        let input = document.createElement('select');

        let empty = document.createElement('option');
        empty.innerHTML = '';
        empty.setAttribute('value', '0');
        input.append(empty);

        if(this.optionsParsed && this.optionsParsed.length > 0) {
            for (let option of this.optionsParsed) {
                let opt = document.createElement('option');
                opt.innerHTML = option.label || '';
                opt.setAttribute('value', option.value || '0');

                input.append(opt);
            }
        }

        if (options.onBlur) {
            let valueOnEnter = null;
            input.addEventListener('focus', () => {
                valueOnEnter = input.value;
            });
            input.addEventListener('blur', () => {
                if (input.value !== valueOnEnter) {
                    options.onBlur()
                }
            });
            input.addEventListener('change', (e) => {
                if (e.target.value !== valueOnEnter) {
                    options.onBlur()
                }
            });
        }

        input.setAttribute('name',`sheet-${this.name || this.nameId}`);

        if (this.props.auto) {
            input.setAttribute('readonly','readonly');
        }

        container.classList.add('sheet-container');
        input.classList.add('sheet-inputtext');

        this.elements = {container, input};
        this.update(options);

        container.append(input);

        target.append(container);
    }

    update(options) {
        this.elements.container.style.fontSize = `${options.unit}px`;
        this.elements.container.style.backgroundColor = options.highlight ? '#444' : 'transparent';
        this.elements.container.style.gridRowStart = 1 + this.y;
        this.elements.container.style.gridColumnStart = 1 + this.x;
        this.elements.container.style.gridRowEnd = (1 + this.y) + (this.height);
        this.elements.container.style.gridColumnEnd = (1 + this.x) + (this.width);

        this.elements.container.classList[options.selectedId === this.id ? 'add' : 'remove']('selected');

        this.elements.input.style.height = `${options.unit * this.height}px`;
        this.elements.input.style.fontSize = `${options.unit * 0.6667}px`;
        this.elements.input.title = this.props.name || this.props.nameId;

        if (this.props.textSize) {
            this.elements.input.style.fontSize = (options.unit * 0.6667 * parseFloat(this.props.textSize)) + 'px';
        }
    }

    set(value) {
        this.elements.input.value = value;
    }

    get() {
        return this.elements.input.value;
    }

    clean() {
        this.elements.input.value = '';
    }

    error() {
        this.elements.input.classList.add('error');
    }

    fix() {
        this.elements.input.classList.remove('error');
    }

}